// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-A4p","label":"styles_label__3MTf2"};